import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import { getEnv, getLoggedUserGPID } from 'utils';

function TagManagerComponent() {
    const tagManagerArgs = {
        gtmId: `GTM-${getEnv('REACT_APP_GTM_ID')}`,
        dataLayer: {},
    };

    const employee2Api = useMutation((params) => axios.get(`${endPoints.employee.listV2}?key=${params?.gpid}`));

    useEffect(() => {
        if (getLoggedUserGPID() && !employee2Api?.data?.data) {
            employee2Api?.mutate({ gpid: getLoggedUserGPID() });
        }
    }, [getLoggedUserGPID()]);

    useEffect(() => {
        if (getLoggedUserGPID() && employee2Api?.isSuccess) {
            const employeeData = employee2Api?.data?.data;
            tagManagerArgs.dataLayer = {
                event: 'user_login',
                user_id: `2448${getLoggedUserGPID()}8805`,
                authentication_status: 'logged_in',
                user_bu: employeeData?.[0]?.businessUnitName || '',
                user_mu: employeeData?.[0]?.managementUnitName || '',
                user_sector_name: employeeData?.[0]?.sectorName || '',
            };
            TagManager?.dataLayer(tagManagerArgs);
        }
    }, [employee2Api?.isSuccess]);

    useEffect(() => {
        TagManager.initialize(tagManagerArgs);
    }, []);

    return null;
}

export default TagManagerComponent;
